"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = void 0;
var _react = _interopRequireDefault(require("react"));
require("react-loading-skeleton/dist/skeleton.css");
require("./override.css");
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * This is, in short, a re-export of react-loading-skeleton but
 * with a few props removed from the interface to ensure visual consistency
 * across zApps.
 */

var Skeleton = props => {
  return /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, props);
};
exports.Skeleton = Skeleton;
//# sourceMappingURL=Skeleton.js.map